import { render, staticRenderFns } from "./ExperienceCard.vue?vue&type=template&id=5170a353&scoped=true&"
import script from "./ExperienceCard.vue?vue&type=script&lang=js&"
export * from "./ExperienceCard.vue?vue&type=script&lang=js&"
import style0 from "./ExperienceCard.vue?vue&type=style&index=0&id=5170a353&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5170a353",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VFlex,VIcon,VImg,VLayout})
